module.exports = __webpack_public_path__ + "static/media/assembly2.bfbff7df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly2.png
// module id = 2420
// module chunks = 0